import { Component, inject, OnInit } from '@angular/core';
import {
  DsEmptyStateModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
} from '@bmw-ds/components';
import { SharedService } from 'src/app/services/shared-service';

@Component({
  selector: 'app-home',
  imports: [DsEmptyStateModule],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home implements OnInit {
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'homeLoader',
  };
  loadingAreaService = inject(DsLoadingAreaService);
  sharedService = inject(SharedService);
  ngOnInit(): void {
    // this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    // this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
    this.sharedService.showUIElementsSubject.next(true);
  }
}
